import { type TFunction } from "i18next";

import { WithInjectedName } from "models";

export const injectNames = <T extends { translationSlug: string }>(items: T[], t: TFunction, prefix: string): Array<WithInjectedName<T>> =>
  items.map((item) => ({ ...item, name: t(`${prefix}.${item.translationSlug}`) }));
